import { AxiosResponse } from "axios";
import { coreAxios } from "../axios";

export function getValueByKey(key: string): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/dictionary/${key}`)
}

export function updateValueByKey(key: string, value: string): Promise<AxiosResponse<any>> {
    return coreAxios.put(`/dictionary/${key}/${value}`)
}